import React from 'react';
import { EntityId } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../_config/react/useAppDispatch';
import { AttachmentsDialog } from '../../../../App/app/common/modals/components/AttachmentsDialog';
import { setSuccess } from '../../../../App/core/notification/notification.slice';

import { AttachedDocs } from '../../../Domain/Bons/entities';
import { selectPlanningById } from '../../../Domain/Planning/selectors';
import { attachFileToPlanning, retrievePlanningAttachment } from '../../../Domain/Planning/use-cases';

interface Props {
    id: EntityId;
    open: boolean;

    onClose(): void;
}

export const PlanningAttachmentDialogs = ({ id, open, onClose }: Props) => {
    const planning = useSelector(selectPlanningById(id));

    const dispatch = useAppDispatch();

    const handleDownload = async (doc: AttachedDocs) => {
        const res = await dispatch(retrievePlanningAttachment({ planningId: id, fileId: doc._id })).unwrap();
        const fileURL = window.URL.createObjectURL(res);
        window.open(fileURL);
    };

    const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = event.target;

        if ( files && files.length > 0 ) {
            const res: any = await dispatch(attachFileToPlanning({ id, file: files[0] }));
            if ( !res.error ) {
                dispatch(setSuccess(`Le fichier ${res.payload.originalname} a bien été sauvegardé.`));
            }
        }
    };

    return (
        <AttachmentsDialog
            data={planning}
            open={open}
            onClose={onClose}
            handleDownload={handleDownload}
            handleUpload={handleUpload}
        />
    );
};
